/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Chrome/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Video from 'DesignSystem/Video/react'



/** @type {import('Simple/types.js').View} */
export default function Chrome({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State/Error/Content/Guides/Chrome",
  src
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<Video
  viewPath={`${viewPath}/Video`}
 marginTop={dtSpaceS}
 src={src}
 autoPlay={true}
 controls={true}
 muted={true}
 playsInline={true}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 text="1. Click the icon to the left of the 'admin.greyfinch.com' URL in the address bar."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="2. Find 'Microphone' in the permissions list and toggle it on or set it to 'Allow'."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="3. Refresh the page when prompted."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="4. Greyfinch should now have access to your microphone."
/>
{children}
</React.Fragment>)
}